import { find, intersection, union } from 'lodash';

export interface IPasswordAlertType {
  type: string;
  msg: string;
}

export const PASSWORD_ALERTS = [
  {
    type: 'match',
    msg: 'Passwords must match.',
  },
  {
    type: 'minlength',
    msg: 'Password must be at least 8 characters long.',
  },
  {
    type: 'pattern',
    msg:
      'Passwords must contain 1 uppercase character (A-Z) and 1 special character ' +
      '(~!@#$%^&*_-+=`|\\(){}[]:;"\'<>,.?/).',
  },
];

export const validatePassword = (password: string): boolean => {
  return (
    /(?=.*[A-Z])/.test(password) &&
    /[~!`\\|:;"'<>,?/@#$%^&*)(\][}{+=._-]/g.test(password)
  );
};

const checkAlert = (
  oldErrors: IPasswordAlertType[],
  newErrors: IPasswordAlertType[],
): IPasswordAlertType[] => {
  let errors: IPasswordAlertType[] = [];
  if (newErrors.length < oldErrors.length) {
    errors = intersection(oldErrors, newErrors);
  } else if (newErrors.length > oldErrors.length) {
    errors = union(oldErrors, newErrors);
  } else if (newErrors.length === oldErrors.length) {
    errors = newErrors;
  }
  return errors;
};

const checkErrorList = (
  errors: IPasswordAlertType[],
  errorType: IPasswordAlertType,
): IPasswordAlertType | undefined => {
  return find(errors, (val) => val.type === errorType.type);
};

export const checkUpdatePasswordRules = (
  password: string,
  confirmPassword: string,
  oldErrors: IPasswordAlertType[],
): IPasswordAlertType[] => {
  const errors: IPasswordAlertType[] = [];

  if (!password && !confirmPassword) {
    return errors;
  }

  if (!password) {
    if (!checkErrorList(errors, PASSWORD_ALERTS[0])) {
      errors.push(PASSWORD_ALERTS[0]);
    }
    return checkAlert(oldErrors, errors);
  }

  if (!validatePassword(password)) {
    if (!checkErrorList(errors, PASSWORD_ALERTS[2])) {
      errors.push(PASSWORD_ALERTS[2]);
    }
  }

  if (password.length < 8) {
    if (!checkErrorList(errors, PASSWORD_ALERTS[1])) {
      errors.push(PASSWORD_ALERTS[1]);
    }
  }

  if (password !== confirmPassword) {
    if (!checkErrorList(errors, PASSWORD_ALERTS[0])) {
      errors.push(PASSWORD_ALERTS[0]);
    }
  }
  return checkAlert(oldErrors, errors);
};
